class PrintBoxUtil {
  constructor() {

    this.apiBase = "/apps/v1"; //production 
    ///this.apiBase = "/apps/staging"; //staging
  }

  xhrify(url, data, xhrOptions) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: xhrOptions.type || 'GET',
        url: url,
        data: data,
        headers: xhrOptions.headers || {},
        dataType: xhrOptions.dataType || 'json',
        success: (data) => {
          resolve(data)
        },
        error: (xhr, status, errThrown) => {
          console.error("printboxutil.xhrify", xhr)
          console.error("printboxutil.xhrify", status)
          console.error("printboxutil.xhrify", errThrown)
          reject(errThrown);
        }
      });
    });
  }

  generateOverlay(message, parent) {
    //mainOverlay container
    let mainC = document.getElementById("pbx-overlay-33");
    if (message) {
      document.getElementById('pbx-overlay-content-msg').innerText = message;
    }

    if(parent){
      parent.appendChild(mainC);
    }

    mainC.style.width = "100%";
  }

  clearOverlay() {
    document.getElementById("pbx-overlay-33").style.width = "0%";
  }

}